<script lang="ts">import { cfgBrandTitle, cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
</script>

<div class="swiper-slide">
	<div>
		<div class="banner-img">
			<img src={cfgToThemeCdnPath(`/banner/top-banner.png`)} alt={cfgBrandTitle()} />
		</div>
		<div class="banner-caption"></div>
	</div>
</div>

<style>
	.swiper-slide {
		display: flex;
		align-items: center;
		justify-content: center;
}

	.banner-img {
		display: block;
	}

	.banner-caption {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		padding: 1rem;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
	}

	.banner-caption h2 {
		color: white;
	}

	.banner-caption h1 {
		color: #fed51c;
		font-family: var(--font-main);
		font-weight: 800;
		font-size: 18px;
		line-height: 24px;
		letter-spacing: 1px;
	}
</style>
